// index.ts — entry point for the info-panel bundle.
//
// esbuild bundles everything reachable from here into
// includes/js/dist/info-panel-bundle.js (IIFE). Home for client-side creature
// "info panel" renderers that read from window.FateTide.casterCache instead of
// pinging a PHP endpoint. First panel: the essence breakdown (replaces
// options/tools/encounter_creatures/encounter_creature_info/essence_info_inc.php).

import { renderEssenceInfoPanel } from './essence-breakdown';
import { renderCreatureHealthInfoPanel, rollVitalityPreview } from './health-info';
import { renderArmorClassInfoPanel } from './ac-info';
import { renderDamageMitigationInfoPanel } from './damage-mitigation-info';
import { renderLuckFortuneInfoPanel } from './luck-info';
import { renderManaSpiritInfoPanel } from './mana-info';
import { renderMovementSenseInfoPanel } from './movement-sense-info';
import { renderReachInfoPanel, renderSizeInfoPanel } from './reach-info';
import { renderAttacksInfoPanel } from './attacks-info';
import { renderSkillAdvDisInfoPanel } from './skill-adv-dis-info';
import { renderDefenseCategoryInfoPanel, renderDefenseTypeInfoPanel, renderStatusImmunityInfoPanel, renderPermanentStatusInfoPanel } from './defenses-info';
import { renderCreatureSummaryInline, renderVManaEcacLuckBarsInline, renderActionBarHpMana, renderActionBarAp } from './creature-summary';
import { renderStatusEffectButtonsInline } from './creature-buttons';
import { renderCreatureConsoleInline, renderCreatureGmControlsInline, renderCreatureStatusEffectsInline, ftConfirmDeleteEncounterCreature, renderActionBarStatusCluster, renderActionBarCreatureGmControls, ftCreatureRadialActions, ftCreatureRadialThumbnail } from './creature-console';
import { renderCasterSpecialActionsInline, renderEndConcentrationButtonsInline, renderActionBarContextualActions } from './creature-action-buttons';
import { renderHungerInfoPanel, renderThirstInfoPanel } from './hunger-thirst-info';
import { rerenderActiveInfoPanel } from './active-panel';

declare global {
    interface Window {
        renderEssenceInfoPanel: typeof renderEssenceInfoPanel;
        renderCreatureHealthInfoPanel: typeof renderCreatureHealthInfoPanel;
        rollVitalityPreview: typeof rollVitalityPreview;
        renderArmorClassInfoPanel: typeof renderArmorClassInfoPanel;
        renderDamageMitigationInfoPanel: typeof renderDamageMitigationInfoPanel;
        renderLuckFortuneInfoPanel: typeof renderLuckFortuneInfoPanel;
        renderManaSpiritInfoPanel: typeof renderManaSpiritInfoPanel;
        renderMovementSenseInfoPanel: typeof renderMovementSenseInfoPanel;
        renderSizeInfoPanel: typeof renderSizeInfoPanel;
        renderReachInfoPanel: typeof renderReachInfoPanel;
        renderAttacksInfoPanel: typeof renderAttacksInfoPanel;
        renderSkillAdvDisInfoPanel: typeof renderSkillAdvDisInfoPanel;
        renderDefenseCategoryInfoPanel: typeof renderDefenseCategoryInfoPanel;
        renderDefenseTypeInfoPanel: typeof renderDefenseTypeInfoPanel;
        renderStatusImmunityInfoPanel: typeof renderStatusImmunityInfoPanel;
        renderPermanentStatusInfoPanel: typeof renderPermanentStatusInfoPanel;
        renderCreatureSummaryInline: typeof renderCreatureSummaryInline;
        renderVManaEcacLuckBarsInline: typeof renderVManaEcacLuckBarsInline;
        renderActionBarHpMana: typeof renderActionBarHpMana;
        renderActionBarAp: typeof renderActionBarAp;
        renderStatusEffectButtonsInline: typeof renderStatusEffectButtonsInline;
        renderCreatureConsoleInline: typeof renderCreatureConsoleInline;
        renderCreatureGmControlsInline: typeof renderCreatureGmControlsInline;
        renderCreatureStatusEffectsInline: typeof renderCreatureStatusEffectsInline;
        renderActionBarStatusCluster: typeof renderActionBarStatusCluster;
        renderActionBarCreatureGmControls: typeof renderActionBarCreatureGmControls;
        ftConfirmDeleteEncounterCreature: typeof ftConfirmDeleteEncounterCreature;
        ftCreatureRadialActions: typeof ftCreatureRadialActions;
        ftCreatureRadialThumbnail: typeof ftCreatureRadialThumbnail;
        renderCasterSpecialActionsInline: typeof renderCasterSpecialActionsInline;
        renderEndConcentrationButtonsInline: typeof renderEndConcentrationButtonsInline;
        renderActionBarContextualActions: typeof renderActionBarContextualActions;
        renderHungerInfoPanel: typeof renderHungerInfoPanel;
        renderThirstInfoPanel: typeof renderThirstInfoPanel;
        ftRerenderOpenInfoPanel: typeof rerenderActiveInfoPanel;
    }
}

Object.assign(window, {
    renderEssenceInfoPanel,
    renderCreatureHealthInfoPanel,
    rollVitalityPreview,
    renderArmorClassInfoPanel,
    renderDamageMitigationInfoPanel,
    renderLuckFortuneInfoPanel,
    renderManaSpiritInfoPanel,
    renderMovementSenseInfoPanel,
    renderSizeInfoPanel,
    renderReachInfoPanel,
    renderAttacksInfoPanel,
    renderSkillAdvDisInfoPanel,
    renderDefenseCategoryInfoPanel,
    renderDefenseTypeInfoPanel,
    renderStatusImmunityInfoPanel,
    renderPermanentStatusInfoPanel,
    renderCreatureSummaryInline,
    renderVManaEcacLuckBarsInline,
    renderActionBarHpMana,
    renderActionBarAp,
    renderStatusEffectButtonsInline,
    renderCreatureConsoleInline,
    renderCreatureGmControlsInline,
    renderCreatureStatusEffectsInline,
    renderActionBarStatusCluster,
    renderActionBarCreatureGmControls,
    ftConfirmDeleteEncounterCreature,
    ftCreatureRadialActions,
    ftCreatureRadialThumbnail,
    renderCasterSpecialActionsInline,
    renderEndConcentrationButtonsInline,
    renderActionBarContextualActions,
    renderHungerInfoPanel,
    renderThirstInfoPanel,
});
